import { jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import DaySelectionEdge from '../day-selection-edge/index.esm.js';
import styles from '../../../styles/uitk-egds-calendar.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const inRangeEdgeCaseClasses = {
  EndRangeEdge: 'uitk-calendar-day-selection-range-end',
  UnconfirmedEndRangeEdge: 'uitk-calendar-day-selection-range-end',
  SingleDate: 'uitk-calendar-day-selection-range-start',
  StartRangeEdge: 'uitk-calendar-day-selection-range-start',
  UnconfirmedStartAndEndSameDayEdge: 'uitk-calendar-day-selection-range-start',
  WithinRangeFirstOfMonth: 'uitk-calendar-day-selection-in-range-first-of-month',
  WithinRangeLastOfMonth: 'uitk-calendar-day-selection-in-range-last-of-month'
};
const getInRangeBackgroundClass = selectionType => inRangeEdgeCaseClasses[selectionType] || 'uitk-calendar-day-selection-in-range';
const DaySelection = props => {
  const {
    children = null,
    selectionType
  } = props;
  const inRangeBackgroundClass = React.useMemo(() => getClassNameList('uitk-calendar-day-selection', getInRangeBackgroundClass(selectionType)), [selectionType]);
  if (selectionType === 'Unselected') {
    return children ? jsx(Fragment, {
      children: children
    }) : null;
  }
  const daySelectionProps = {
    className: inRangeBackgroundClass
  };
  return jsx("div", {
    ...daySelectionProps,
    children: jsx(DaySelectionEdge, {
      selectionType: selectionType,
      children: children
    })
  });
};
export { DaySelection as default };